import React, { useState } from 'react';
import "./CabBooking.css";
import prevIcon from "../../assets/icons/coloredPrev.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from 'react-redux';
import {setCabRequests} from "../../redux/userSlice.js";
import useAuth from '../../customHooks/useAuth.js';
import { toast } from 'react-toastify';
import axios from 'axios';
import { baseUrl } from '../../common/baseUrl.js';
import axiosInstance from '../../axiosInstance/axiosInstance.js';
import { toHotelISO } from "../../common/hotelTime";

export default function UpdateCabBooking() {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    //Refresh Handle
    useAuth();
    
    const [errors, setErrors] = useState({});
    // const pick_up_location = location.state?.pick_up_location || "";
    // const time = location.state?.time || "";
    const bookingId = location.state?.bookingId || "";
    const cabRequestData = location.state?.cabRequestData || {};
    // const number_of_people = location.state?.people || 0;

    
  // Format Date 
  const formatDateToISO = (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0'); // Local hours
    const minutes = String(date.getMinutes()).padStart(2, '0'); // Local minutes
  
    // Format as "YYYY-MM-DDTHH:mm"
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };


  // Editing a time means the same as picking one: the wall clock the guest sees is hotel
  // time, so it is sent the same way the create screen sends it.
  const formatLocalToISO = (localDateTime) => toHotelISO(localDateTime);




  // User Id 
  const userId = useSelector((state) => state.user.userId);

  // State for form fields and validation
  const [formData, setFormData] = useState({
    pickupLocation:  cabRequestData.pick_up_location,
    time:  formatDateToISO(cabRequestData.time_of_arrival),
    number_of_people : cabRequestData.number_of_people
  });

  // Backward Button
  const handleClick = () => {
    navigate("/bookings",{state : {activeRequests : "requests"}});
  };

  // Function to handle form validation
  const validateForm = (data) => {
    const newErrors = {};
    const specialCharRegex = /[!@#$%^&*()?:{}|<>]/; // Regex for special characters
    const numberRegex = /^[1-9][0-9]*$/; // Regex to ensure only positive integers greater than 0

    if (!data.pickupLocation.trim()) {
      newErrors.pickupLocation = "Pick up location is required";
    } else if (specialCharRegex.test(data.pickupLocation)) {
      newErrors.pickupLocation = "Special characters are not allowed";
    }

    if (!data.time) {
      newErrors.time = "Time is required";
    }

    if (!numberRegex.test(data.number_of_people)) {
      newErrors.number_of_people = "Number of people must be a positive integer greater than 0 and not start with 0";
    }

    return newErrors;
  };


  // Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));

    const formErrors = validateForm({
      ...formData,
      [name]: value
    });
    setErrors(formErrors);
  };


  // Function to handle form submission
  const handleRequestCab = async () => {
    const formErrors = validateForm(formData);
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      try {

        
        const formattedTime =  formatLocalToISO(formData.time);
        const localDate = formattedTime.toLocaleString(); // This will give you the local time based

        const numberOfPeople = parseInt(formData.number_of_people, 10);
        
        const formInputs = {
          number_of_people: numberOfPeople,
          pick_up_location: formData.pickupLocation,
          time_of_arrival: localDate // Set time in ISO format
        };
        
        // console.log("Form Data  : ", formInputs);

        const response = await axiosInstance.put(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${cabRequestData.booked_room_id}/guest-requests/pre-checkin/cab-request/${cabRequestData.id}`, formInputs);
        // console.log("Response : ", response.data);

        // try{
        //   const response1 = await axiosInstance.get(`/api/v1/users/${userId}/requests`);

        //   const request = response1.data.data;
        //   console.log("Cab Requests Data is in array",Array.isArray(request));

        //   // setRequests(request);
        //   // console.log("Data For Cab Request in set Requests : ",requests);

        //   // console.log("Cab Request Array : ",response1.data.data);
        //   dispatch(setCabRequests(response1.data.data));

        // }
        // catch(error){
        //   console.log(error);

        // }
        toast.success("PreCheckIn Cab Request Updated Successfully");
        navigate("/bookings",{state : {activeRequests : "requests"}})
      } catch (error) {
        toast.error(error?.response?.data?.message || "Some Error Occured");
        console.log(error);
      }
    }
  };

      
  return (
    <div className="cab-booking">
    {/* Header of Page */}
    <div className="cab-header">
      <div className="cab-content">
        <div className='prev-icon' onClick={handleClick}>
          <img src={prevIcon} alt="" />
        </div>
        <div className='cab-data'>
          <div className='cab-data-header'>
            <h6>Book your cab to your stay</h6>
            <p>
              Reserve a comfortable and reliable transportation option for your convenient journey.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div className="pickup">
      {/* Text Area */}
      <div className="textarea-pickup">
        <div className="form-pickup">
          <label htmlFor="pickupText">
            <h4>Pick up Location</h4>
          </label>
        </div>
        <div className="form-textArea">
          <textarea
            name="pickupLocation"
            rows="4"
            cols="10"
            value={formData.pickupLocation}
            onChange={handleChange}
          />
          {errors.pickupLocation && <p className="error-message">{errors.pickupLocation}</p>}
        </div>
      </div>


        {/* Cab Request Number of Guest */}
        <div className="guest">
          <div className="form-guest">
            <label htmlFor="guest">
              <h4>Number of People</h4>
            </label>
          </div>

          <div className="form-guestText">
            <input
              type="text"
              name="number_of_people" // Ensure the name matches the formData key
              value={formData.number_of_people ||  null} // Set value from state
              onChange={handleChange}
              maxLength={2}

            />
            {errors.number_of_people && <p className="error-message">{errors.number_of_people}</p>}
          </div>
        </div>

      <div className="request-cab">
        <div className="request-cab-header">
          <h4>When do you want the cab</h4>
        </div>
        <div className="request-cab-btns">
          <div className="request-cab-time">
            <input
              type="datetime-local"
              name="time"
              value={formData.time}
              onChange={handleChange}
            />
            {errors.time && <p className="error-message">{errors.time}</p>}
          </div>
          <div className="request-cab-btn">
            <button
              onClick={handleRequestCab}
              disabled={Object.keys(errors).length > 0 || formData.time === "" || formData.pickupLocation === ""}
            >
              Request Cab
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}
